import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import Select from 'components/Select';
import IconButton from 'components/IconButton';
import DateRangePicker from 'components/DateRangePicker';

import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';

import './styles.css';

const BottomRightFixedCustomOverlay = ({
  children,
  onBlur,
  onFocus,
  tabIndex,
  input
}: any) => {
  // Custom Overlay will be fixed to bottom right from input

  const position = input.parentElement.getBoundingClientRect();

  return (
    <div
      className="BottomRightFixedCustomOverlay"
      onBlur={onBlur}
      onFocus={onFocus}
      tabIndex={tabIndex}
      style={{right: 20, top: position.top + position.height}}>
      <div className="OverlayWrapper colab-small-border-radius">{children}</div>
    </div>
  );
};

interface StatusWithDateRangeFilterProps {
  statusValue: Array<string>;
  data: Array<{label: string; value: string}>;
  onStatusChange: (value: Array<string>) => void;
  start: string | null;
  end: string | null;
  onDateChange: (fieldName: string, date: string) => void;
  classNameForTesting?: string;
}

class StatusWithDateRangeFilter extends React.Component<
  StatusWithDateRangeFilterProps
> {
  state = {
    sectionOpened: false
  };

  toggleSection = () => {
    this.setState({sectionOpened: !this.state.sectionOpened});
  };

  onChange = options => {
    this.props.onStatusChange(_.get(options, 'value'));
  };

  render() {
    return (
      <div
        className={classNames(
          'FilterSection StatusWithDateRangeFilter',
          {
            'FilterSection--opened': this.state.sectionOpened
          },
          this.props.classNameForTesting
        )}>
        <div className="FilterSection__header colab-centered-v colab-bold">
          <IconButton
            src={arrowRightIcon}
            srcActive={arrowDownIcon}
            alt="Toggle section"
            onClick={this.toggleSection}
            active={this.state.sectionOpened}
          />
          <div>Room occupancy statuses</div>
        </div>

        <div className="FilterSection__content">
          <Select
            multi={false}
            searchable={true}
            value={this.props.statusValue}
            options={this.props.data}
            onChange={this.onChange}
          />
          {this.props.statusValue && (
            <DateRangePicker
              className="colab-small-border-radius"
              overlayComponent={BottomRightFixedCustomOverlay}
              start={this.props.start}
              end={this.props.end}
              handleChange={this.props.onDateChange}
            />
          )}
        </div>
      </div>
    );
  }
}

export default StatusWithDateRangeFilter;
